import React, { useEffect, useState, useRef, useCallback  } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {BASE_URL} from '../../lib/constant';
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';

const DynamicProductList = ({productList,baseUrl,dispatch,searchList=false,selectedColour}) => {
	const [needToRender, setNeedToRender] = useState(false);
	const [loaderText, setLoaderText] = useState(false);
	const sortBy = useRef('matname|asc');
	var actualProducts = [];
    var lastProductNotVisited=true;
    var listHaveMoreData=true;
    var lastProductPositionLeft=0;

    const addCompareList=async (matnum) => { 
        await AuthVerify.addToCompares(matnum).then((data) => {
            if(data){
                dispatch({type:'COMPARE'});
            }
        })
    }

    useEffect(() => {
        // if(productList){
            AuthVerify.setCartChanged();

            listHaveMoreData=true;
            setNeedToRender(productList)
            actualProducts=productList;
            window.addEventListener('scroll', handleScroll);
            if(!(productList?.length>0)) {
                setLoaderText("Sorry, there is no product.");
            }
        // }
        
    }, [productList])

    const loadMoreData = async () =>{
        if(productList?.length>0 && baseUrl && lastProductNotVisited && listHaveMoreData){
            await AuthVerify.selectedColours().then(async (selectedColours) =>{
                setLoaderText("Products are loading ...")
                var sortByData = sortBy.current.split('|');
                const requestUrl=searchList?
                baseUrl+`&offset=${actualProducts?.length}&limit=${actualProducts?.length+15}&sortby=${sortByData[0]}&orderby=${sortByData[1]}${selectedColours}`:
                baseUrl+`?offset=${actualProducts?.length}&limit=${actualProducts?.length+15}&sortby=${sortByData[0]}&orderby=${sortByData[1]}${selectedColours}`;
                await Axios.get(requestUrl)
                .then(function (response) {
                if (response && response.status == 200) {
                    lastProductNotVisited=true;
                    if(searchList){
                        var data=response.data?.data;
                        if(data.items){
                            actualProducts=actualProducts.concat(data.items);
                            setNeedToRender(actualProducts);
                        }else{
                            setLoaderText("There are no more item.");
                            listHaveMoreData=false;
                        }
                    }
                    else{
                        var data=response.data;
                        if(data[0].items){
                            actualProducts=actualProducts.concat(data[0].items);
                            setNeedToRender(actualProducts);
                        }else{
                            setLoaderText("There are no more item.");
                            listHaveMoreData=false;
                        }
                    }
                    
                }
                })
                .catch(function (error) {
                });
            })
            
        }
    }

    const handleFilter =async (e) => {
        await AuthVerify.addSortByProducts(e.target.value).then(() => {
            setNeedToRender([])
            actualProducts=[];
            sortBy.current=e.target.value;
            loadMoreData();
        })
    }

	const handleScroll = () => {
        if(document.getElementById('lastDPitem')){
            lastProductPositionLeft = lastProductPositionLeft<document.getElementById('lastDPitem').getBoundingClientRect().bottom?document.getElementById('lastDPitem').getBoundingClientRect().bottom:lastProductPositionLeft;
            // console.log("View",lastProductPositionLeft,actualProducts.length)
            if(lastProductPositionLeft<Math.ceil(window.innerHeight + document.documentElement.scrollTop) && productList){
                // console.log(Math.ceil(window.innerHeight + document.documentElement.scrollTop),(document.documentElement.offsetHeight-1000),Math.ceil(window.innerHeight + document.documentElement.scrollTop) > (document.documentElement.offsetHeight-1000));
                // setLoaderText("Loading More Items...")
                // console.log("Actual Product",actualProducts.length);
                loadMoreData();
                lastProductNotVisited=false;
            }
        }
        
        
		// if (
		// 	Math.ceil(window.innerHeight + document.documentElement.scrollTop) > (document.documentElement.offsetHeight-1000) ||
		// 	isFetching
		// )
        //     return;
		// setIsFetching(true);
	};

    const addToWishlist = async (matnum,wishlist) => {
        if(wishlist){
          await AuthVerify.removeFromWishlist(matnum);
        }else{
          await AuthVerify.addToWishlist(matnum);
        }
        window.setProductActiveOrNot(matnum,wishlist);
        let oldProducts=needToRender;
        oldProducts.map(item=>{
            if(item.matnum==matnum){
                item.wishlist=!wishlist;
            }
        })
        setNeedToRender(oldProducts);
      }
    
    const RenderData =({data})=>{
        return (<Row className="products-grid" id={"products-grid"}>
        {
            data.map((product,i) => (
                <Col className={"productDetailsDiv item"} lg={2} md={3} sm={3} xs={6} key={i} id={needToRender?.length===i+1 ? 'lastDPitem' : `notLast_${i}`}>
                    <div className="item-inner" key={i}>
                        <div className="item-img">
                            <div className="item-img-info">
                                <Link
                                    className="product-image"
                                    title={product?.matname} 
                                    to={"/product-detail?matnum="+product?.matnum}
                                >
                                    <img
                                        alt={product?.matname}
                                        // src={img03}
                                        // src={BASE_URL+product?.imageurl}
                                        src={AuthVerify.getImageLink(product?.imageurl)}
                                        height="358px"
                                    />
                                </Link>
                                <div className={(product?.status === "New" && "new-label new-top-left") ||
                                (product?.promotag && "hot-label hot-top-left") ||
                                (product?.stock === "Sold out" && "soldout-label new-top-left") || "hidden"}>
                                {(product?.status === "New" && product?.status) ||
                                    (product?.promotag && product?.promotag) ||
                                    (product?.stock === "Sold out" && product?.stock) || ""}</div>
                                {/* <div className={product?.discount !== null || "hidden"}>{product?.discount}</div> */}
                                <div className={product?.contract ? "contract-label" : "hidden"}>{product?.contract && "contract"}</div>
                                <div className="jtv-box-hover">
                                    <ul className="add-to-links">
                                        <li>
                                            <Link className="link-quickview" to="/product-list" style={{background:"none",border:"none"}}>
                                                <i className="icon-magnifier-add icons"></i>
                                                <span className="hidden">Quick View</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <button className={`link-wishlist matnum-${product?.matnum} ${product.wishlist?'active':''}`} onClick={()=>addToWishlist(product?.matnum, product.wishlist)} style={{background:"none",border:"none"}}>
                                                <i className="icon-heart icons"></i>
                                                <span className="hidden">Add to Wishlist</span>
                                            </button>
                                        </li>
                                        {product.allowcomparison && 
                                        <li>
                                            <button className="link-compare" onClick={()=>addCompareList(product?.matnum)} style={{background:"none",border:"none"}}>
                                                <i className="icon-shuffle icons"></i>
                                                <span className="hidden">Compare</span>
                                            </button>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="item-info">
                            <div className="info-inner">
                                <div className="item-title" style={{padding:"0 7px"}}>
                                    <Link title={product.matname} to={"/product-detail?matnum="+product?.matnum}>
                                        {product.matname}
                                    </Link>
                                </div>
                                <div className="item-content">
                                    <div className="rating">
                                        <i className={product.rating>0?"fa fa-star":"fa fa-star-o"}></i>
                                        <i className={product.rating>1?"fa fa-star":"fa fa-star-o"}></i>
                                        <i className={product.rating>2?"fa fa-star":"fa fa-star-o"}></i>
                                        <i className={product.rating>3?"fa fa-star":"fa fa-star-o"}></i>
                                        <i className={product.rating>4?"fa fa-star":"fa fa-star-o"}></i>
                                    </div>
                                    <div className="item-price">
                                        <div className="price-box">
                                            <span className="regular-price">
                                                <span className="price">{`S$${product.sellingprice?.toFixed(2)} (w/GST S$${product.gstprice?.toFixed(2)})`}</span>
                                                {product.promoprice && 
                                                <>
                                                    <br/>
                                                    <span  style={{color:'grey',textDecoration:'line-through', fontlastProductPositionLeft:'14px'}} className="price">U.P. S${product.usualprice}</span>
                                                </>
                                                }
                                                {product.sellingprice != product.usualprice && !product.promoprice && false &&
                                                    <>
                                                        <br />
                                                        <span style={{ color: 'grey', textDecoration: 'line-through', fontlastProductPositionLeft: '14px' }} className="price">U.P. S${product.usualprice}</span>
                                                    </>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    <div className="action">
                                        <button
                                            className="button btn-cart"
                                            type="button"
                                            title=""
                                            data-original-title="Add to Cart"
                                            onClick={()=>AuthVerify.addTocart(product)}
                                        >
                                            <span>Add to Cart</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            ))}
    </Row>);
    }

    return (
        <>
        <div className="toolbar">
          <Row>
            <Col md={7} sm={5}>
              {/* <div className="btn-group">
                <div id="grid-view" className="btn btn-default active" data-toggle="tooltip" title="Grid"><Link to="/product-list"><i className="fa fa-th"></i></Link></div>
                <div id="list-view" className="btn btn-default" data-toggle="tooltip" title="List"><Link to="/product-list"><i className="fa fa-th-list"></i></Link></div>
              </div>
              <Link to="/category" id="compare-total">Product Compare (3)</Link> */}
            </Col>

            {/* <Col sm={2} className="text-right sort-by">
              <label className="control-label" htmlfor="input-sort">Sort By:</label>
            </Col>

            <Col md={3} sm={2} className="text-right">
              <select name="product" id="products" style={{width:"70%"}} onChange={handleFilter}>
                <option value="matname|asc">Name</option>
                <option value="sellingprice|asc">Lowest Price</option>
                <option value="sellingprice|desc">Highest Price</option>
              </select>
            </Col> */}

            {/* <Col sm={1} className="text-right show-limit">
              <label className="control-label" htmlFor="input-limit">Show:</label>
            </Col>

            <Col sm={2} className="text-right select-lable-none">
              <select name="product" id="products">
                <option value="item 1">Product 1 </option>
                <option value="item 2">Product 2 </option>
                <option value="item 3">Product 3 </option>
                <option value="item 4">Product 4 </option>
              </select>
            </Col> */}
          </Row>
        </div>
        <div className="category-products">
        {needToRender && needToRender?.length>0 && 
            <RenderData data={needToRender}/>
        }
        {loaderText&&
            <div className="toolbar">
                <Row>
                    <Col sm={12} className="text-center">
                    <ul className="pagination">
                        <li><span style={{fontSize:'16px'}}>{loaderText}</span></li>
                    </ul>
                    </Col>
                </Row>
            </div>
        }
        </div >
        </>
        
    )
}

export default DynamicProductList